import css from 'styled-jsx/css';

const styles = css`@import './styles/global-variables';
.clearfix {
    overflow: auto;
  }
.Lottery-Campaing-Loginsection{
    width: 940px;
    margin: 20px auto 118px;
    position: relative;    
    .Lottery-Campaing-PI{
        // width: 80%;
        margin: 0 auto;
        text-align: center;
    .pi{
        width:48%;
        text-align: center;
        background-color: $purple-ultra-light;
        display: inline-block;
        border: 1px solid #ccc;
        border-radius: 5px;
        .title {
            text-align: center;
            font-size: 18px;
            font-family: "SourceSansPro-bold";
            color: $purple;
            margin: 30px 0 40px;
            position: relative;
            &::after {
                position: absolute;
                content: "";
                height: 4px;
                bottom: -16px;
                margin: 0 auto;
                left: 0;
                right: 0;
                width: 60px;
                background: $purple;
            }
        }
        .txt{
            color:$purple;
            width:100%;
            font-family: "SourceSansPro-bold";
            font-weight: normal;
            font-size: 18px;
            padding: 30px 0;
        }
        .cta{
            background: url('https://images.ctfassets.net/8g0fievzqg8k/10lCfZCzMQT3Pl7gSMcoyO/629921ac98051fe46e0eaffb5c44b277/Lottery_button_login.png') no-repeat 5px 0px;
            background-size: 100% 100%;
            margin:0 auto;
            text-align:center;
            padding:4px 20px;
            // background:$purple;
            width: 80%;
            height:80px;
            font-family: "M PLUS Rounded 1c", sans-serif;
            font-weight: 500;
            font-size: 28px;
            letter-spacing: 5px;
            border-radius: 100px;
        }      

        .registration {
            background: url('https://images.ctfassets.net/8g0fievzqg8k/7AtzKPdp930GPhg0XtOYty/835dbf7c2bc2f67a9910cf26bc4cb297/PC_button_register.jpg') no-repeat 5px 0px;
            background-size: 100% 100%;
        }

        .continue {
            background: url('https://images.ctfassets.net/8g0fievzqg8k/6aD2j9zuSnNFFNbnhrjn9M/d189b4520ffc836c86256ccff32bea6f/Lottery_button_oubo.png') no-repeat 5px 0px;
            background-size: 100% 100%;
        }
        
        .log-image-wrap {
            width:100%;
            margin : 40px 0 10px;

            img {
                width: 100%;
            }

        }
        
    }
    .pi-left {
        float: left;
        background: #fff;
       
    }
    .pi-right {
        float: right;     
    }
    .align-center {
        margin: 0px 25%;
    }

    // .Coupon-Campaing-Login{
    //     // margin-right:20px;
    // }
    
}
@media only screen and (max-width: $breakpoint-max){
    width:100%;
    margin: 0px auto 50px;
    padding:0 20px;
    .Lottery-Campaing-PI{
        width:100%;
        // padding: 0 20px;
    .pi{
        width:100%; 
        margin:20px 0; 
        .txt{
            font-size: 24px;
        }
        .cta{
            height: 60px;
            font-size: 20px;
            letter-spacing: 1px;
        }    
    }
    
}

}
@media only screen and (min-width: 769px) and (max-width: 1024px)and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 2){
    .cta{
        font-size: 22px !important;
    } 
}
    
}


@media only screen and (max-width: 767px) {
.Lottery-Campaing-Loginsection{

    .Lottery-Campaing-PI{

        .pi{
            width: 100%;
            display: block;
        }
        
    }

 }
}`;

export default styles;